export const COMPONENT_CRASH = 'Component-Crash';
export const NOT_FOUND = 'Not-Found';
export const INVALID_TEST_CODE = 'Invalid-Test-Code';
export const GET_API_ERROR = 'Get-Api-Error';
export const INIT_REWARD_SPONSOR = 'Init-Reward-Sponsor';
export const INIT_REWARD_PROMO = 'Init-Reward-Promo';
export const GET_USER_LATEST_ENTRIES = 'Get-User-Latest-Entries';
export const CREATE_ENTRIES = 'Create-Entries';
export const GET_HAS_GAME_RESULT_RECORDS = 'Get-Has-Game-Result-Records';
export const CHECK_REDUCE_POINT_STATUS = 'Check-Reduce-Point-Status';
export const CHECK_PASSCODE_STATUS = 'Check-Passcode-Status';
export const SUBMIT_PASSCODE = 'Submit-Passcode';
export const VERIFY_PASSCODE = 'Verify-Passcode';
export const KKBOX_API = 'KKbox-Api';
export const GET_KKBOX_USER_POINT = 'Get-KKbox-User-Point';
export const REDUCE_KKBOX_POINT = 'Reduce-KKbox-Point';
export const GET_WINNER = 'Get-Winner';
export const PRIZE_REDEEM_WITHDRAW_NOT_FOUND = 'Prize-Redeem-Withdraw-Not-Found';
export const GET_WINNER_TASK = 'Get-Winner-Task';
export const GET_WINNER_QUALIFY = 'Get-Winner-Qualify';
export const PICK_PRIZE_LOTTERY_NO_REMAINDER = 'Pick-Prize-Lottery-No-Remainder';
export const JOIN_GAME = 'Join-Game';
export const JOIN_PURE_PRIZE_GAME = 'Join-Pure-Prize-Game';
export const INVOICE_VALIDATION = 'Invoice-Validation';
export const PURCHASE_REWARD_SUBMIT_DEAD_LOCK = 'Purchase-Reward-Submit-Dead-Lock';
export const PURCHASE_REWARD_SUBMIT_FAILED = 'Purchase-Reward-Submit-Failed';
export const REDEEM_FORM = 'Redeem-Form';
export const SIGNUP_FORM = 'Signup-Form';
export const FILL_FORM_DUPLICATE = 'Fill-Form-Duplicate';
export const GET_FORM_REDIRECT_URL = 'Get-Form-Redirect-Url';
export const RESULT_PAGE = 'Result-Page';
export const PRIZE_PAGE_WINNER_INFO = 'Prize-Page-Winner-Info';
export const INVALID_PRIZE_PAGE_WINNER_INFO = 'Invalid-Prize-Page-Winner-Info';
export const PRIZE_OPEN_WINNER = 'Prize-Open-Winner';
export const PRIZE_PAGE_GET_CODE = 'Prize-Page-Get-Code';
export const PRIZE_PAGE_STORE_REDEEM = 'Prize-Page-Store-Redeem';
export const PLAY_NEW_ENTRIES = 'Play-New-Entries';
export const PUSH_REDEEM_PRIZE_URL = 'Push-Redeem-Prize-Url';
export const LOGIN_LONG_TERM_FAILED = 'Login-Long-Term-Failed';
export const LOGIN_GET_ACCESS_TOKEN_FAILED_REWARD_INIT =
    'Login-Get-Access-Token-Failed-Reward-Init';
export const LIFF_INIT_FAILED = 'Liff-Init-Failed';
export const UGC_SUBMIT_VOTE = 'Ugc-Submit-Vote';
export const LINE_FRIEND_QUALIFY_VALIDATION_FAILED = 'Line-Friend-Qualify-Validation-Failed';
export const MEMORY_MATCH_START_GAME_FAILED = 'Memory-Match-Start-Game-Failed';
export const GET_MEMBER_POINT_FAILED = 'Get-Member-Point-Failed';
export const GET_POINT_POOL_INFO_FAILED = 'Get-Point-Pool-Info-Failed';
export const REDEEM_POINT_FAILED = 'Redeem-Point-Failed';
export const TRANSACTION_WITHDRAW_QUANTITY_IS_WRONG = 'Transaction-Withdraw-Quantity-Is-Wrong';
export const PHOTO_MERGE_FAILED = 'Photo-Merge-Frame-Failed';
export const UPLOAD_FILE_FAILED = 'Upload-File-Failed';
export const SUBMIT_REFERRIAL_CODE_FAILED = 'Submit-Referral-Code-Failed';
export const MGM_LOTTERY_VALIDATION_FAILED = {
    REFERRAL_ENTRY_NOT_FOUND: 'Mgm-Lottery-Validation-Failed-By-ReferralEntry-Not-Found',
    EXCEPTION: 'Mgm-Lottery-Validation-Failed'
};
export const MGM_CREATE_ENTRY_FAILED = 'Mgm-Create-Entry-Failed';
export const GET_API_ERROR_AND_NO_REFRESH_BTN = 'Get-Api-Error-And-No-Refresh-Btn';
export const SHARE_TARGET_PICKER_OPEN_FAILED = 'Share-target-picker-open-failed';
export const SHARE_TARGET_PICKER_INIT_FAILED = 'Share-target-picker-init-failed';
export const INFINITE_SCROLL = 'infinite-scroll';
export const WINNER_NOT_FOUND = 'Winner-Not-Found';
export const FORM_DATA_WINNER_NOT_FOUND = 'Form-Data-Winner-Not-Found';
export const POINTS_IS_NOT_ENOUGH_BY_PRE_CHECK =
    'Promotion status is Pause - points is not enough by pre-check';
export const POINTS_IS_NOT_ENOUGH = 'Promotion status is Pause - points is not enough';
export const FAILED_TO_FETCH = 'Failed-To-Fetch';
export const FAILED_TO_LOAD = 'Failed-To-Load';
export const PREFLIGHT_RESPONSE_IS_NOT_SUCCESSFUL = 'Preflight-Response-Is-Not-Successful';
export const NOT_ALLOWED_BY_ACCESS_CONTROL_ALLOW_ORIGIN =
    'Not Allowed By Access Control Allow Origin';
export const DNS_LOOK_UP_FAILED = 'DNS-Look-Up-Failed';
export const SSL_CONNECTION_ERROR = 'SSL-Connection-Error';
export const WEB_KIT_ERROR = 'Web-Kit-Error';
export const PROMO_NOT_FOUND = 'Promo-Not-Found';
export const LIFF_INIT_AUTH_FAILED = 'Liff-Init-Auth-Failed';
export const UGC_GET_MEDIA_COUNTS = 'Ugc-Get-Media-Counts';
export const ORDER_REWARD_THIRD_PARTY_API_ERROR = 'Order-Reward-Third-Party-Api-Error';
export const CART_REWARD_THIRD_PARTY_API_ERROR = 'Cart-Reward-Third-Party-Api-Error';
export const ENTRY_FLOW_HAS_GAME_RESULT = 'Entry-Flow-Has-Game-Result';
export const CHECK_POINT_CARD_FAILED = 'Check-Point-Card-Failed';
export const CHECK_TASK_COMPLETED_RECORD_FAILED = 'Check-Task-Completed-Record-Failed';
export const TASK_AND_RELATED_PROMO_DISCONNECT = 'Task-And-Related-Promo-Disconnect';
export const STORE_GAME_RESULT_ENTRY_FLOW_EXISTS = 'Store-Game-Result-Entry-Flow-Exists';
export const POINT_IS_LOCKED = 'Point-Is-Locked';
export const THIRD_PARTY_API_TIMED_OUT = 'Third-Party-Api-Timed-Out';
export const LOGIN_USER_INFO_FAILED = 'Login-User-Info_Failed';
export const PSYCHO_QUIZ_RESULT_PAGE_FAILED = 'Psycho-Quiz-Result-Game-Failed';
export const SURVEY_RESULT_PAGE_FAILED = 'Survey-Result-Game-Failed';
export const QUIZ_RESULT_PAGE_FAILED = 'Quiz-Result-Game-Failed';
export const TOKEN_ERROR = 'Token-Error';
export const LOGIN_BY_LIFF_TOKEN_ERROR = 'Login-By-Liff-Token-Error';
export const NOTIFY_MEMBER_NOT_FOUND = 'Notify-Member-Not-Found';
export const NOTIFY_EMAIL_NOT_VALID = 'Notify-Email-Not-Valid';
export const NOTIFY_DRIVER_NOT_SUPPORT = 'Notify-Driver-Not-Support';
export const NOTIFY_CREATE_FAILED = 'Notify-Create-Failed';
export const NOTIFY_MISSING_REQUIRED_FIELDS = 'Notify-Missing-Required-Fields';
export const ENTRY_REACH_TOTAL_LIMIT = 'Entry-Reach-Total-Limit';
